module.exports = __webpack_public_path__ + "img/ms_my.c7742485.png";